import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn,AppInputFieldBtnCancel 
} from './../../../../../widget/styledComponents/input_field.style'
import React ,{ useRef,useState } from "react";
import { gql, useMutation } from '@apollo/client';
import Cookies from 'js-cookie';
import LocationAutocomplete from './../widgets/autocomplete_inputfield';
import { Spinner, toaster } from 'evergreen-ui';

export const ADD_ESTATE = gql`
mutation Facility_create($name: String!, $address: String!, $country: String!, $state: String!, $city: String!) {
  facility_create(name: $name, address: $address, country: $country, state: $state, city: $city) {
    code
    success
    error
    data {
      _id
      code
      name
      facilityManager
      totalProperties
      occupiedProperties
      availableProperties
      address
      country
      state
      city
      createdAt
      id
    }
  }
}
`;


function AddEstatePopupWidget() {
    const accesTokenValue = Cookies.get('userAccessToken');

    const [addEstate, { loading }] = useMutation(ADD_ESTATE);
    
    const handleSubmit=(e)=>{
        e.preventDefault()
        
       
      
        addEstate({
          variables: { 
            name: nameRef.current.value,
            address:address,
            country: selectedLocation.country,
            state:selectedLocation.state,
            city: selectedLocation.city,
          },
          context: {
            headers: {
              Authorization: `Bearer ${accesTokenValue}`,
            },
          },
        })
        .then((response) => {
          toaster.success("Estate added successfully.")
          window.location.reload()
        })
        .catch((error) => {
          toaster.danger(error.message)
        });
      }
    
    
    const nameRef = useRef(null);
    
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [address, setAddress] = useState('');
    
    const handleSelectLocation = (latLng, address,country,state,city) => {
      setSelectedLocation({
        country,
        state,city
      });
      setAddress(address);
    };
  return (
    <div>
        <form onSubmit={handleSubmit}>
          <div className='row'>
                  <div className='col s12 '>
                      <InputFieldTitleText>
                          Estate Name
                      </InputFieldTitleText>
                      <AppInputField
                          type="text" 
                          placholder="alijames@gmail.com"
                          ref={nameRef}
                      required/> 
                  </div>
                 
                  
                  
                  <div className='col s12 '>
                      <InputFieldTitleText>
                          Location
                      </InputFieldTitleText>
                      <LocationAutocomplete onSelect={handleSelectLocation} />
                      {selectedLocation && (
                          <div>
                            <small>Address: {address}</small>
                          </div>
                      )}
                  </div>
                  
                  <div className='row'>
                      
                      <div className='col s12 right' style={{
                          display:"flex",
                          flexWrap:"wrap",
                          justifyContent:"end"
                      }}>
                          
                          <div className='' style={{
                              width:"100px",
                              padding:"16px "
                          }}>
                              <AppInputFieldBtnCancel 
                          >
                                  Cancel
                              </AppInputFieldBtnCancel >
                          </div>
                          <div className='' style={{
                              width:"120px",
                              padding:"16px "
                          }}>
                              {loading  &&
                              <center>
                                <Spinner/>
                              </center>
                              }
                              {!loading &&
                                <AppInputFieldBtn className='' disabled={loading}>
                                    Add
                                </AppInputFieldBtn>
                              }
                              
                          </div>
                      </div>
                  </div>
                  <br/>
          </div>
        </form>
    </div>
  )
}

export default AddEstatePopupWidget